// @flow
import React from 'react';
import { Provider } from 'react-redux';
import App from './App';

type Props = {
  initializedStore: Object
};

const BrowserApp = ({ initializedStore }: Props) => (
  <Provider store={initializedStore}>
    <App />
  </Provider>
);

export default BrowserApp;
